import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  licenseDisplayLabel: {
    id: 'course-authoring.schedule-section.license.license-display.label',
    defaultMessage: 'License display',
  },
  licenseDisplayParagraph: {
    id: 'course-authoring.schedule-section.license.license-display.paragraph',
    defaultMessage: 'The following message will be displayed at the bottom of the courseware pages within your course:',
  },
});

export default messages;
